// app/javascript/controllers/ticket_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['form'];

    connect() {
        const inputs = this.formTarget.querySelectorAll('input');
        inputs.forEach(input => {
            input.addEventListener("change", this.enableSubmit.bind(this));
        });
    }

    enableSubmit() {
        this.element.classList.add('unsaved-ticket');

        const input = this.formTarget.querySelector('input[type="submit"]');
        input.disabled = false
        input.value = "Save"
    }

    remove(event) {
        event.preventDefault();
        // Remove the row – assumes the delete button is within the .ticket-consignment-row container
        const row = this.element;
        if (row) {
            row.remove();
        }
    }
}